import { TextElement } from '@app/common';
import TextWithReferences from '../TextWithReferences/TextWithReferences';

type Properties = {
    data: TextElement;
};

const Text = (props: Properties) => {
    return <p className="page-text"><TextWithReferences text={props.data.text} /></p>;
};
export default Text;